import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import {
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from 'ngx-google-analytics';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfigService } from './core/services/config.service';

const configs = require('../assets/config.json');

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    RecaptchaV3Module,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient, configService: ConfigService) =>
          new TranslateHttpLoader(http, `./assets/i18n/`, '.json'),
        deps: [HttpClient, ConfigService],
      },
    }),
    NgxGoogleAnalyticsModule.forRoot(configs['GA_TRACKING_ID'] || ''),
    NgxGoogleAnalyticsRouterModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,
      countDuplicates: true,
      enableHtml: true,
    }),
  ],
  bootstrap: [AppComponent],
  providers: [
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: ConfigService) => () =>
        configService.loadConfig(),
      deps: [ConfigService],
      multi: true,
    },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: configs['RECAPTCHA_SITE_KEY'] },
  ],
})
export class AppModule {}
